/* tslint:disable */
import { EquipGenZone } from './equip-gen-zone';

/**
 */
export class NewEquipment {
    tempSetPoint?: number;
    typeCalculate?: number;
    versionEquipment?: number;
    equipmentId1?: number;
    equipmentId2?: number;
    nameEquipment?: string;
    dwellingTime?: number;
    newPos?: number;
    typeEquipment?: number;
    fanFrequency?: number;
    equipGenZone?: EquipGenZone[];
    checkFanFrequency?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/new-equipment.ts